import React, { useState } from "react";
import Nonorder from "./Nonorder";
import OrderSchdule from "./Table/OrderSchdule";
import Itemsdata from "./Table/Itemsdata";
import Pickitemsdata from "./Table/Pickitemsdata";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";

export default function PickingList() {
  const [status, setStatus] = useState(1); // 0: no show, 1: show yes, 2: show no.

  const radioHandler = (status) => {
    setStatus(status);
  };
  return (
    <div className=" flex flex-col container max-w-4xl mt-2 mb-5 xl:max-w-7xl">
      <div className="flex mt-10">
        <div class=" inline-flex w-16 mt-3 ml-4 mr-2 bg-blue-300 rounded-full h-0.5 "></div>
        <p className="text-blue-300">Picking for</p>
      </div>
      <div class="inline-flex float-left mt-4 ml-5">
        <div class="form-check form-check-inline">
          <input
            class=" form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio1"
            value="option1"
            checked={status === 1}
            onClick={(e) => radioHandler(1)}
          />
          <label
            class="form-check-label inline-block ml-1 mr-4 text-gray-800"
            for="inlineRadio10"
          >
            Non-order
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class=" form-check-input ml-10 appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio2"
            value="option2"
            checked={status === 2}
            onClick={(e) => radioHandler(2)}
          />
          <label
            class="form-check-label inline-block text-gray-800 ml-1
            mr-4"
            for="inlineRadio20"
          >
            Order/Schedule
          </label>
        </div>
      </div>
      <div className="">
        {status === 1 && (
          <div className=" mt-8">
            <Nonorder />
          </div>
        )}
        {status === 2 && (
          <div className="flex mt-16">
            <div class="flex flex-wrap justify-center w-full">
              <div class="w-full md:overflow-x-auto  sm:overflow-x-auto mt-8 bg-  mb-4 ">
                <div className="flex flex-wrap  pt-2 -mt-4"></div>
                <div
                  className="tabelcontainer overflow-auto mx-4"
                  // "w-[calc(100vw_-_12rem)]"
                >
                  <OrderSchdule />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="flex ml-5">
          <div class=" inline-flex w-16 mt-3 mb-3 mr-2 bg-blue-300 rounded-full h-0.5 "></div>
          <p className="text-blue-300">Notes</p>
        </div>
        <div class="relative z-0 w-full ml-5 mb-6 group">
          <input
            type="text"
            name="notes"
            class="block py-2.5 px-0 w-2/3 text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
            placeholder=" "
            required
          />
          <label
            for="notes"
            class="peer-focus:font-medium inline-flex absolute text-sm text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-900 peer-focus:dark:text-blue-900 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            <div className="flex">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 13L15 13"
                  stroke="black"
                  stroke-opacity="0.7"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M9 9L13 9"
                  stroke="black"
                  stroke-opacity="0.7"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M9 17L13 17"
                  stroke="black"
                  stroke-opacity="0.7"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M19 13V15C19 17.8284 19 19.2426 18.1213 20.1213C17.2426 21 15.8284 21 13 21H11C8.17157 21 6.75736 21 5.87868 20.1213C5 19.2426 5 17.8284 5 15V9C5 6.17157 5 4.75736 5.87868 3.87868C6.75736 3 8.17157 3 11 3V3"
                  stroke="black"
                  stroke-opacity="0.7"
                  stroke-width="2"
                />
                <path
                  d="M18 3L18 9"
                  stroke="black"
                  stroke-opacity="0.7"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M21 6L15 6"
                  stroke="black"
                  stroke-opacity="0.7"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>{" "}
            Notes
          </label>
        </div>
        <div className="flex">
          <div class=" inline-flex w-16 mt-3 ml-5 mr-2 bg-blue-300 rounded-full h-0.5 "></div>
          <p className="text-blue-300">List Items</p>
        </div>
        
        <div className="flex flex-wrap justify-center">
        <div
          className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
          // "w-[calc(100vw_-_12rem)]"
        >
          {/* <Itemsdata /> */}
          <Itemsdata />
        </div>
      </div>
        <div className="text-center w-fit align-middle m-auto text-blue-400 cursor-pointer pb-2">
          {" "}
          <button
            type="button"
            class="text-blue-900  bg-white border shadow-md  font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
          >
            <svg
              width="26"
              height="28"
              viewBox="0 0 26 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.439 2L13.3563 15.5L1.71945 2"
                stroke="#1F78B4"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
       
        <div className="flex flex-wrap justify-center">
        <div
          className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
          // "w-[calc(100vw_-_12rem)]"
        >
          {/* <Itemsdata /> */}
          <Pickitemsdata />
        </div>
      </div>
        <div className="flex p-6  ">
          <div className="float-left">
            <button
              className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="button"
            >
              Cancel
            </button>
          </div>
          <div className="float-right ml-auto">
          <Link to="/dashboard/management/PickinglistDetails" >
            <button
              className="bg-green-500  text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="button"
            >
              Schedule
            </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
